import { v4 as uuidv4 } from 'uuid';

import { Component, Element, h, Host, Prop, State } from '@stencil/core';

/*
    play content when scoll observer sees content as inview
*/

const defaultObserverOptions: IntersectionObserverInit = {
  root: null,
  threshold: 1,
  rootMargin: '0px 0px 0px 0px',
};

const onIntersecting = (video: HTMLVideoElement, isManualPaused: boolean, togglePaused: (arg: boolean) => void) => {
  //what to do when intersecting, eg video.play()
  if (!isManualPaused) {
    video && video.play();
    togglePaused(false);
  }
};

const onNotIntersecting = (video: HTMLVideoElement, togglePaused: (arg: boolean) => void) => {
  //what to do when not intersecting, eg video.pause()
  video && video.pause();
  togglePaused(true);
};

@Component({
  tag: 'pn-play-on-scroll',
  styleUrl: 'pn-play-on-scroll.scss',
})
export class PnPlayOnScroll {
  @Element() hostElement: HTMLElement;
  @Prop() videoSrc: string = '';
  @Prop() observerOptions: IntersectionObserverInit = defaultObserverOptions;
  @Prop() showOverlay: boolean = false;
  @State() videoId: string = '';
  @State() isManuallyPaused: boolean = false;
  @State() isPaused: boolean = false;
  localObserverOptions: IntersectionObserverInit;

  testAdditionalParamIntoCallback: boolean = true;
  video: HTMLVideoElement;

  generateUniqueId() {
    return uuidv4();
  }

  componentWillLoad() {
    this.videoId = this.generateUniqueId();
  }

  componentDidLoad() {
    this.video = document.getElementById(this.videoId) as HTMLVideoElement;
    this.video.addEventListener('click', this.handlePlayPauseClicked);
    this.localObserverOptions = this.observerOptions;
  }

  handlePlayPauseClicked = () => {
    if (this.video.paused || this.video.ended) {
      this.video.play();
      this.isManuallyPaused = false;
      this.isPaused = false;
    } else {
      this.video.pause();
      this.isManuallyPaused = true;
      this.isPaused = true;
    }
  };

  togglePaused = (paused: boolean) => {
    this.isPaused = paused;
  };

  render() {
    return (
      <Host>
        <pn-scroll
          intersectFunc={() => onIntersecting(this.video, this.isManuallyPaused, this.togglePaused)}
          notIntersectFunc={() => onNotIntersecting(this.video, this.togglePaused)}
          shouldLoop={true}
          behaviourClasses={'some-behaviour-class'}
          observerOptions={this.localObserverOptions}
        >
          <div slot="scroll-affected">
            <video playsinline muted autoPlay id={`${this.videoId}`}>
              <source src={this.videoSrc} type="video/mp4" />
            </video>
            <pn-video-overlay showOverlay={this.showOverlay} isPaused={this.isManuallyPaused || this.isPaused} onPlayPauseClicked={this.handlePlayPauseClicked}></pn-video-overlay>
          </div>
        </pn-scroll>
      </Host>
    );
  }
}
